import React, { Component } from "react";
import ModalWidget from "./templates/modal";
import Functions from "../../src/functions";

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			main: [],
			header: [],
			loaded: false,
		};
	}

	componentDidMount() {
		this.setState({ loaded: true });
		Functions.addCSS("/resources/prepaid/css/style.css");
		Functions.addCSS("/resources/prepaid/css/jquery.jscrollpane.css");
		Functions.addCSS("/resources/prepaid/css/mobile.css");
		Functions.addCSS("/resources/prepaid/css/frog.css");
		Functions.addCSS("/resources/prepaid/css/custom.css");
		Functions.addScript("/resources/prepaid/js/jquery-1.8.3.min.js");
		Functions.addScript("/resources/js/dlp.libraries.1.0.js");
		Functions.addScript("/resources/prepaid/js/dlp.prepaid.main.1.0.js");
		Functions.addScript("/resources/prepaid/js/jquery.easing.1.3.js");
		Functions.addScript("/resources/prepaid/js/jquery.backstretch.min.js");
		Functions.addScript("/resources/prepaid/js/jquery.mousewheel.js");
		Functions.addScript("/resources/prepaid/js/mwheelIntent.js");
		Functions.addScript("/resources/prepaid/js/jquery.jscrollpane.min.js");
		Functions.addScript("/resources/prepaid/js/main.js");
		Functions.addScript("/resources/js/deeplink.js");
		Functions.addScript("/resources/js/remote-logger.js");
	}

	render() {
		if (this.state.loaded) {
			return (
				<div
					id="wrapper"
					className="wrapper"
					style={{ minHeight: "694px" }}>
					{this.state.main}
					<ModalWidget
						ref={(refComponent) => {
							window["modal"] = refComponent;
						}}></ModalWidget>
					<ModalWidget
						ref={(refComponent) => {
							window["modal2"] = refComponent;
						}}></ModalWidget>
				</div>
			);
		}
		return "";
	}
}

export default Index;
